import { searchTypesEnum } from "@/types/common/filters";

export const getListType = (searchType: string) => {
  if (searchType === searchTypesEnum.user) {
    return "usuarios";
  }
  if (searchType === searchTypesEnum.roles) {
    return "roles";
  }
  if (searchType === searchTypesEnum.tags) {
    return "etiquetas";
  }
  if (searchType === searchTypesEnum.positions) {
    return "cargos";
  }
  if (searchType === searchTypesEnum.institutions) {
    return "instituciones";
  }
  return "unknown";
};
